// Helper function for error logging
const logError = (message: string, error: unknown) => {
  if (error instanceof Error) {
    console.error(`${message}: ${error.message}`);
  } else {
    console.error(message);
  }
};

// Helper function to fetch data from the API
const fetchData = async () => {
  try {
    const response = await fetch('https://www.ftl.no/veileder.json');
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    logError('Error fetching data', error);
    return null;
  }
};

export const loadData = async () => {
  try {
    const fetchedData = await fetchData();

    if (fetchedData) {
      return fetchedData;
    } else {
      return null;
    }
  } catch (error) {
    logError('Error fetching data', error);
    return null;
  }
};
